module.exports = __webpack_public_path__ + "static/media/5.81ed73e1.jpg";